import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
import { PractitionersPage } from './pages/PractitionersPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { AppLaunchPage } from './pages/AppLaunchPage';
import { PractitionerJoinPage } from './pages/PractitionerJoinPage';
import { PractitionerWelcomePage } from './pages/PractitionerWelcomePage';
import { PractitionerPaymentSetupPage } from './pages/PractitionerPaymentSetupPage';
import { PractitionerAccountMembershipPage } from './pages/PractitionerAccountMembershipPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { TermsOfSalePage } from './pages/TermsOfSalePage';
export function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" data-mp="28s31dk1f0dz5" />;
  }
  if (path === '/practitioners/join') {
    return <PractitionerJoinPage initialStep="account" data-id="element-1" data-mp="23t8hsfvmildz" />;
  }
  if (path === '/practitioners/membership') {
    return <PractitionerJoinPage initialStep="membership" data-id="element-2" data-mp="3mlj8gtrwtb2j" />;
  }
  if (path === '/practitioners/welcome') {
    return <PractitionerWelcomePage data-id="element-3" data-mp="3rcj2nr9n9f1c" />;
  }
  if (path === '/practitioners/account/membership') {
    return <PractitionerAccountMembershipPage data-id="element-4" data-mp="5os92t1uy7l" />;
  }
  if (path === '/practitioners/setup-payments') {
    return <PractitionerPaymentSetupPage data-id="element-5" data-mp="2zllff2q1qmn9" />;
  }
  if (path === '/terms-of-service') {
    return <TermsOfServicePage data-id="element-6" data-mp="33morde4z3yj7" />;
  }
  if (path === '/terms-of-sale') {
    return <TermsOfSalePage data-id="element-7" data-mp="33oriy2lrxzq1" />;
  }
  if (path === '/practitioners') {
    return <PractitionersPage data-id="element-8" data-mp="38l04pyuh8r66" />;
  }
  if (path === '/privacy-policy') {
    return <PrivacyPolicyPage data-id="element-9" data-mp="3dle3sre3oqs2" />;
  }
  if (path === '/get-the-app') {
    return <AppLaunchPage data-id="element-10" data-mp="3dii6n5a2u64o" />;
  }
  return <FemEntityLanding data-id="element-11" data-mp="nwc2huqftzxb" />;
}